<div class="container-fluid">
	<h1 class="my-3 text-capitalize">{{ecommerce.id ? 'Actualizar':'Agregar'}} Ecommerce</h1>
	<form ngNativeValidate (submit)="save()">
		<div class="card p-3">
			<div class="row p-3">
				<div class="col-6 col-md-4">
					<label class="">Nombre</label>
					<input type="text" name="name" [(ngModel)]="ecommerce.name" class="form-control" required>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Precio</label>
					<select class="form-control" [(ngModel)]="ecommerce.price_list_id" name="price_list_id" required>
						<option value="">Seleccione</option>
						<option *ngFor="let price_list of price_list" [ngValue]="price_list.id">{{price_list.name}}</option>
					</select>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Store</label>
					<select class="form-control" [(ngModel)]="ecommerce.store_id" name="store_id" required>
						<option value="">Seleccione</option>
						<option *ngFor="let store of store_list" [ngValue]="store.id">{{store.name}}</option>
					</select>
				</div>

				<div class="col-6 col-md-4">
					<label class="">Tipo de consumo</label>
					<select class="form-control" [(ngModel)]="ecommerce.price_type_id" name="price_type_id" required>
						<option value="">Seleccione</option>
						<option *ngFor="let price_type of price_type_list" [ngValue]="price_type.id">{{price_type.name}}</option>
					</select>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Logo</label>
					<app-image-uploader [(image)]="ecommerce.logo_image_id"></app-image-uploader>
				</div>
				<div class="col-6 col-md-4">
					<label class="">Banner</label>
					<app-image-uploader [(image)]="ecommerce.banner_image_id"></app-image-uploader>
				</div>

				<div class="col-6 col-md-4">
					<label class="">Color</label>
					<input type="color" name="color" [(ngModel)]="ecommerce.color" class="form-control">
				</div>
				<div class="col-6 col-md-4">
					<label class="">Color de Fuente</label>
					<input type="color" name="font_color" [(ngModel)]="ecommerce.font_color" class="form-control">
				</div>

			</div>
			<div class="row p-3">
				<div class="col-12 text-right">
					<button type="submit"  [disabled]="is_loading" class="btn btn-primary">Guardar</button>
				</div>
			</div>
		</div>
	</form>
</div>
